import { render, staticRenderFns } from "./ConfirmAccountDetail.vue?vue&type=template&id=120624fa&scoped=true"
import script from "./ConfirmAccountDetail.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAccountDetail.vue?vue&type=style&index=0&id=120624fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120624fa",
  null
  
)

export default component.exports